import MapMarkerIcon from '@assets/icons/map-marker.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import {
  MAP_COMPACT_SIZE,
  MARKER_ICON_HEIGHT,
  MARKER_SIZE,
} from '@/experiences/sales-portal/components/map/constants';
import { View } from 'react-native';

const MARKER_SCALE = 0.6;

export const MapPlaceholder: React.FC = () => {
  const [styles, theme] = useStyles();

  return (
    <View
      accessibilityElementsHidden
      aria-hidden
      importantForAccessibility="no-hide-descendants"
      style={styles.container}
    >
      <MapMarkerIcon
        fill={theme.sk.color.icon.tertiary}
        height={MARKER_ICON_HEIGHT * MARKER_SCALE}
        width={MARKER_SIZE * MARKER_SCALE}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.secondary.default,
    borderRadius: theme.sk.radii.radiusLarge,
    height: MAP_COMPACT_SIZE,
    justifyContent: 'center',
    overflow: 'hidden',
    width: MAP_COMPACT_SIZE,
  },
}));
